import createIcon from '../../createIcon';

/**
 * @component @name Mp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk02LjUgOUgxMUMxMS41NSA5IDEyIDkuNDUgMTIgMTBWMTVIMTAuNVYxMC41SDkuNVYxMy41SDhWMTAuNUg3VjE1SDUuNVYxMEM1LjUgOS40NSA1Ljk1IDkgNi41IDlaTTE1LjUgMTVIMTRWOUgxNy41QzE4LjA1IDkgMTguNSA5LjQ1IDE4LjUgMTBWMTIuNUMxOC41IDEzLjA1IDE4LjA1IDEzLjUgMTcuNSAxMy41SDE1LjVWMTVaTTE1LjUgMTJIMTdWMTAuNUgxNS41VjEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Mp = createIcon('Mp', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM6.5 9H11C11.55 9 12 9.45 12 10V15H10.5V10.5H9.5V13.5H8V10.5H7V15H5.5V10C5.5 9.45 5.95 9 6.5 9ZM15.5 15H14V9H17.5C18.05 9 18.5 9.45 18.5 10V12.5C18.5 13.05 18.05 13.5 17.5 13.5H15.5V15ZM15.5 12H17V10.5H15.5V12Z',
      key: '1iljg1',
    },
  ],
]);

export default Mp;
